import { render, staticRenderFns } from "./team-member-detail.vue?vue&type=template&id=44d69a8c&scoped=true"
import script from "./team-member-detail.vue?vue&type=script&lang=js"
export * from "./team-member-detail.vue?vue&type=script&lang=js"
import style0 from "./team-member-detail.vue?vue&type=style&index=0&id=44d69a8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d69a8c",
  null
  
)

export default component.exports